export default "__VITE_ASSET__06cdb4ea__"